import { useEffect, useState, useRef } from "react";
import { Line } from "react-chartjs-2";
import { getChart, getChartTable } from "../network_requests";
import {
  Grid,
  TextField,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  TablePagination,
  TableContainer,
  Paper,
  CircularProgress,
  Checkbox,
  Button,
} from "@material-ui/core";
import axios from "axios";

const BasicCheckbox = (props) => {
  const { setISINString, ISINString, row, page } = props;
  const [checked, setChecked] = useState(null);

  useEffect(() => {
    const checked_ = ISINString?.split("|")?.find(
      (value) => value === row.ISIN
    );
    setChecked(checked_);
  }, [page]);

  return (
    <Checkbox
      color="primary"
      checked={checked}
      onChange={(event) => {
        const check = event.target.checked;
        setISINString(
          check
            ? ISINString + "|" + row.ISIN
            : ISINString?.replace(`|${row.ISIN}`, "")
        );
        setChecked(!checked);
      }}
    />
  );
};

const IndexGraph = () => {
  const [historical_data, setHistorical_data] = useState([]);
  const [dataTable, setDataTable] = useState(null);
  const [dateLabels, setDateLabels] = useState([]);
  const [query, setQuery] = useState(null);
  const [name, setName] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [load, setLoad] = useState(false);
  const [ISINString, setISINString] = useState("");
  const [period, setPeriod] = useState("all");

  useEffect(() => {
    if (query) {
      setISINString("");
      setLoad(true);
    }
  }, [query]);

  useEffect(() => {
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();
    (async () => {
      if (ISINString === "" && query) {
        const _dataset = await getChart(query, source, period, "20");
        var dataArray = [];
        var dateArray = [];
        _dataset?.theme_index?.map((item) => {
          dataArray.push(item.normalize);
          const labels = item.Date.split("-");
          dateArray.push(`${labels[1]}.${labels[0]}.`);
        });
        const _dataTable = await getChartTable(query);
        setDataTable(_dataTable);
        setHistorical_data([...dataArray]);
        setDateLabels([...dateArray]);
        setLoad(false);
      } else {
        if (ISINString !== "") {
          const _dataset = await getChart(query, source, period, ISINString);
          var dataArray = [];
          var dateArray = [];
          _dataset?.theme_index?.map((item) => {
            dataArray.push(item.normalize);
            const labels = item.Date.split("-");
            dateArray.push(`${labels[1]}.${labels[0]}.`);
          });
          setHistorical_data([...dataArray]);
          setDateLabels([...dateArray]);
          setLoad(false);
        }
      }
    })();

    return () => {
      source.cancel();
    };
  }, [ISINString, period, query]);

  const data = () => {
    return {
      labels: [...dateLabels],
      datasets: [
        {
          data: [...historical_data],
          fill: false,
          borderColor: "#0040ff",
          pointRadius: 0,
          lineTension: 0.1,
          borderWidth: 2,
        },
      ],
    };
  };

  return (
    <TableContainer component={Paper}>
      <div
        style={{
          width: "99.9%",
        }}
      >
        <Grid container justifyContent="flex-end" style={{ padding: "10px" }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setQuery(name);
              }
            }}
          ></TextField>
        </Grid>
        {load ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "10vh 0",
            }}
          >
            <CircularProgress />
          </div>
        ) : null}
        {query && !load ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
              alignItems: "center",
            }}
          >
            <div style={{ width: "50px", marginRight: "20px" }}>
              <Button
                size="small"
                variant="contained"
                color={period === "all" ? "primary" : "inherit"}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "20px",
                  borderRadius: "25px",
                  fontFamily: "Overpass",
                }}
                onClick={() => {
                  setPeriod("all");
                }}
              >
                ALL
              </Button>
              <Button
                size="small"
                variant="contained"
                color={period === "1mo" ? "primary" : "inherit"}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "20px",
                  borderRadius: "25px",
                  marginTop: "10px",
                  fontFamily: "Overpass",
                }}
                onClick={() => {
                  setPeriod("1mo");
                }}
              >
                1mo
              </Button>
              <Button
                size="small"
                variant="contained"
                color={period === "ytd" ? "primary" : "inherit"}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "20px",
                  borderRadius: "25px",
                  marginTop: "10px",
                  fontFamily: "Overpass",
                }}
                onClick={() => {
                  setPeriod("ytd");
                }}
              >
                ytd
              </Button>
            </div>
            <div style={{ width: "757px" }}>
              <Line
                data={data}
                legend={{
                  display: false,
                }}
                options={{
                  responsive: true,

                  maintainAspectRatio: false,
                  // layout: {
                  //   padding: 20,
                  // },
                  scales: {
                    xAxes: [
                      {
                        gridLines: {
                          display: false,
                        },
                        ticks: {
                          maxRotation: 0,
                          maxTicksLimit: 5,
                          fontSize: 10,
                        },
                      },
                    ],
                    yAxes: [
                      {
                        gridLines: {
                          display: true,
                          color: "#fafbfb",
                          zeroLineColor: "#fafbfb",
                        },
                        ticks: {
                          maxTicksLimit: 5,
                          stepSize:
                            data?.max - data?.min > 10
                              ? Math.floor((data?.max - data?.min) / 5)
                              : (data?.max - data?.min) / 8,
                          fontSize: 10,
                          callback: function (value, index, values) {
                            return value + "%";
                          },
                        },
                      },
                    ],
                  },
                }}
              />
            </div>
          </div>
        ) : null}
      </div>
      {dataTable && !load ? (
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {dataTable?.columns?.map((name) => {
                return <TableCell>{name}</TableCell>;
              })}
              <TableCell>Select</TableCell>
              {/* <TableCell>Name</TableCell>
              <TableCell align="right">Invitation_code</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {dataTable?.data
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow>
                  <TableCell>{row.ISIN}</TableCell>
                  <TableCell>{row.Name}</TableCell>
                  <TableCell>{row.Score}</TableCell>
                  <TableCell>{row.MarketCapital}M</TableCell>
                  <BasicCheckbox
                    row={row}
                    ISINString={ISINString}
                    setISINString={setISINString}
                    page={page}
                  />
                </TableRow>
              ))}
          </TableBody>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
              colSpan={3}
              count={dataTable?.data?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={(event, page_) => {
                setPage(page_);
              }}
              onChangeRowsPerPage={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
            />
          </TableRow>
        </Table>
      ) : null}
    </TableContainer>
  );
};

export default IndexGraph;
